import { createSlice } from '@reduxjs/toolkit';
import { getAppList } from './ThunkActions';
import { iAppListState, REDUCER_NAME, iAppListDTO } from './Types';

const initialState: iAppListState = {
  isLoading: false,
  appList: [],
  errorMessage: null,
};

export const appListSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetAppListState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAppList.pending, (state) => {
        state.isLoading = true;
      })
      //   .addCase(getAppList.fulfilled, (state, action) => {
      //     const payload = action.payload;
      //     if (payload && payload.data) {
      //       state.appList = payload.data.data;
      //       state.isLoading = false;
      //     }
      //   })
      //   .addCase(getAppList.fulfilled, (state, action) => {
      //     const payload = action.payload;

      //     // 1. Extract the data
      //     // 2. Use 'as iAppListDTO[]' to satisfy the TypeScript compiler
      //     const actualData = (payload?.data?.data ||
      //       payload?.data ||
      //       []) as iAppListDTO[];

      //     // 3. Assign it to state
      //     state.appList = actualData;
      //     state.isLoading = false;
      //   })
      .addCase(getAppList.fulfilled, (state, action) => {
        const payload = action.payload;
        const rawData = payload?.data?.data || payload?.data;

        if (rawData) {
          // FIX: If it's an object, wrap it in []. If it's already an array, keep it.
          state.appList = Array.isArray(rawData) ? rawData : [rawData];
        } else {
          state.appList = [];
        }
        state.isLoading = false;
      })
      .addCase(getAppList.rejected, (state) => {
        state.errorMessage = 'Failed to fetch app list';
        state.isLoading = false;
      });
  },
});

export const { resetAppListState } = appListSlice.actions;
export default appListSlice.reducer;
